import { useState, useEffect } from 'react';
import { NavLink } from 'react-router-dom';
/** Components */
import Button from 'components/Button';
import Loader from 'components/Loader';
import InvoiceList from './InvoiceList';
/** Services */
import { getAllInvoices } from 'services/clients';
/** Utils */
import { createToast } from 'utils/toast';
/** Styles */
import styles from './Invoices.module.scss';

const Invoices = () => {
  const [invoiceList, setInvoiceList] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getAllInvoices()
      .then(({ data }) => {
        setInvoiceList(data);
        setLoading(false);
      })
      .catch(({ status, response }) => {
        setLoading(false);
        if (status === 401) {
          createToast({
            text: 'No tienes suficientes permisos',
            type: 'error',
          });
          return;
        }

        createToast({ text: response.data.feedback, type: 'error' });
      });
  }, []);

  const handleDeleteInvoices = (ids) => {
    setInvoiceList(invoiceList.filter((invoice) => !ids.includes(invoice.id)));
  };

  return loading ? (
    <Loader />
  ) : (
    <div className={styles.Invoices}>
      <div className={styles.InvoicesHeader}>
        <h1 className="title">Facturas de Clientes</h1>
      </div>
      <div className={styles.InvoicesList}>
        <InvoiceList
          invoices={invoiceList}
          onDeleteInvoices={handleDeleteInvoices}
        />
      </div>
    </div>
  );
};

export default Invoices;
